import { makeStyles } from '@material-ui/core'
import {
  ERROR_COLORS,
  GRAY_COLORS,
  PRIMARY_COLORS,
  SUCCESS_COLORS,
  WARNING_COLORS
} from 'asterX-UI'

export const useRopCardStyles = makeStyles(theme => ({
  icon: {
    padding: '12px 14px',
    borderRadius: '100%',
    marginRight: 10
  },
  cardTitle: {
    color: GRAY_COLORS[700]
  },
  cardValue: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontWeight: 600,
    marginTop: 4
  },
  cardAction: {
    backgroundColor: GRAY_COLORS[50],
    '&:hover .MuiCardActionArea-focusHighlight': {
      opacity: 0
    }
  },
  cardContent: {
    padding: 15
  },
  red: {
    backgroundColor: ERROR_COLORS[100],
    color: ERROR_COLORS[700]
  },
  green: {
    backgroundColor: SUCCESS_COLORS[100],
    color: SUCCESS_COLORS[700]
  },
  primary: {
    backgroundColor: PRIMARY_COLORS[100],
    color: PRIMARY_COLORS[700]
  },
  orange: {
    backgroundColor: WARNING_COLORS[100],
    color: WARNING_COLORS[700]
  }
}))
